import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund API
 */
class DocumentPresetApi extends ApiBase {
  /**
   * Check if preset bane already exists
   * @param {*} presetName
   */
  async checkNameExists(presetName) {
    const request = {
      url: `${this.API_URL}/documentpreset?presetName=${presetName}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return (status >= 200 && status < 300) || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200) {
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }
}

export default new DocumentPresetApi();
